
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class ClientFieldDialog extends Serenity.EntityDialog<ClientFieldRow, any> {
        protected getFormKey() { return ClientFieldForm.formKey; }
        protected getIdProperty() { return ClientFieldRow.idProperty; }
        protected getLocalTextPrefix() { return ClientFieldRow.localTextPrefix; }
        protected getNameProperty() { return ClientFieldRow.nameProperty; }
        protected getService() { return ClientFieldService.baseUrl; }

        protected form = new ClientFieldForm(this.idPrefix);

        private editorOptions: Serenity.PropertyGrid;
        private formatterOptions: Serenity.PropertyGrid;

        constructor() {
            super();

            this.form.FieldName.change(e => this.fieldNameChanged());
            
            this.form.DataType.change(e => this.dataTypeChanged());
            
            this.form.PrimaryKey.change(e => {
                if (this.form.PrimaryKey.value)
                    this.form.IsNotNull.value = true;
            });

            this.form.Expression.change(e => {
                if (!Q.isTrimmedEmpty(this.form.Expression.value)) {
                    this.form.DataType.value = null;
                    this.form.DataPrecision.value = null;
                    this.form.DataScale.value = null;
                    this.form.SqlDefault.value = null;
                    this.form.PrimaryKey.value = false;
                    this.form.IsNotNull.value = false;
                }
                this.updateInterface();
            });

            this.createEditorOptionsGrid();
            this.form.EditorType.changeSelect2(e => this.createEditorOptionsGrid());

            this.createFormatterOptionsGrid();
            this.form.FormatterType.changeSelect2(e => this.createFormatterOptionsGrid());
        }

        private fieldNameChanged() {
            this.form.PropertyName.value = Q.replaceAll(titleize(this.form.FieldName.value || ''), ' ', '');
            this.form.DisplayName.value = titleize(this.form.FieldName.value || '');
        }

        private dataTypeChanged() {
            this.form.DataPrecision.value = null;
            this.form.DataScale.value = null;

            switch (this.form.DataType.value) {
                case "decimal":
                    this.form.DataPrecision.value = 18;
                    this.form.DataScale.value = 2;
                    break;
                case "numeric":
                    this.form.DataPrecision.value = 18;
                    this.form.DataScale.value = 0;
                    break;
                case "nvarchar":
                case "varchar":
                    this.form.DataPrecision.value = 100;
                    break;
                case "time":
                    this.form.DataPrecision.value = 7;
                    break;
                case "varbinary":
                    this.form.DataPrecision.value = 0;
                    break;
            }

            this.updateInterface();
        }

        protected getSaveEntity() {
            var saveEntity = super.getSaveEntity();
            saveEntity.TableSchema = this.entity.TableSchema;
            saveEntity.Tablename = this.entity.Tablename;
            
            if (!Q.isTrimmedEmpty(this.form.Expression.value))
                saveEntity.DataType = "nvarchar";

            var editorParams = {};
            this.editorOptions.save(editorParams);
            saveEntity.EditorParams = $.toJSON(editorParams);
            
            var formatterParams = {};
            this.formatterOptions.save(formatterParams);
            saveEntity.FormatterParams = $.toJSON(formatterParams);

            return saveEntity;
        }

        private createEditorOptionsGrid() {
            var el: JQuery;
            if (this.editorOptions) {
                el = this.editorOptions.element;
                this.editorOptions.destroy();
                this.editorOptions = null;
                el.html('');
            }
            else
                el = $('<div/>').insertAfter(this.form.EditorType.element.closest(".category"));

            var items: Serenity.PropertyItem[];
            var editorType = this.form.EditorType.value;
            if (editorType) {
                var et = Q.getLookup<DataReportEditorTypeItem>("Data.DataReportEditorType")
                    .itemById[editorType];
                if (et)
                    items = et.Options;
            }

            items = Q.deepClone(items || []);
            items.forEach((x, i) => {
                if (x.editorType == "Boolean") 
                    x.editorType = "Serenity.YesNoCheckEditor";
                x.formCssClass = Q.trim((x.formCssClass || '') + " col-sm-6");
            });

            var index = Q.indexOf(items, x => x.name == "lookupKey");
            if (index > 0) {
                var item = items[index];
                items.splice(index, 1);
                items.splice(0, 0, item);
            }

            this.editorOptions = new Serenity.PropertyGrid(el, {
                items: items,
                mode: Serenity.PropertyGridMode.insert,
                idPrefix: this.idPrefix + "EditOpt_"
            });

            this.editorOptions.load({});
        }

        private createFormatterOptionsGrid() {
            var el: JQuery;
            if (this.formatterOptions) {
                el = this.formatterOptions.element;
                this.formatterOptions.destroy();
                this.formatterOptions = null;
                el.html('');
            }
            else
                el = $('<div/>').insertAfter(this.form.FormatterType.element.closest(".category"));

            var items: Serenity.PropertyItem[];
            var formatterType = this.form.FormatterType.value;
            if (formatterType) {
                var et = Q.getLookup<DataReportFormatterTypeItem>("Data.DataReportFormatterType")
                    .itemById[formatterType];
                if (et)
                    items = et.Options;
            }

            items = Q.deepClone(items || []);
            items.forEach((x, i) => {
                if (x.editorType == "Boolean") 
                    x.editorType = "Serenity.YesNoCheckEditor";
                x.formCssClass = Q.trim((x.formCssClass || '') + " col-sm-6");
            });


            var index = Q.indexOf(items, x => x.name == "lookupKey");
            if (index > 0) {
                var item = items[index];
                items.splice(index, 1);
                items.splice(0, 0, item);
            }

            this.formatterOptions = new Serenity.PropertyGrid(el, {
                items: items,
                mode: Serenity.PropertyGridMode.insert,
                idPrefix: this.idPrefix + "FmtOpt_"
            });

            this.formatterOptions.load({});
        }

        loadEntity(entity: ExtensionFieldRow) {

            super.loadEntity(entity);

            this.createEditorOptionsGrid();
            this.editorOptions.load($.parseJSON(Q.trimToNull(entity.EditorParams) || "{}"));

            this.createFormatterOptionsGrid();
            this.formatterOptions.load($.parseJSON(Q.trimToNull(entity.FormatterParams) || "{}"));
        }

        protected updateInterface() {
            super.updateInterface();

            var isExpression = !Q.isTrimmedEmpty(this.form.Expression.value);

            Serenity.EditorUtils.setRequired(this.form.DataType, !isExpression);
            Serenity.EditorUtils.setReadOnly(this.form.DataType, isExpression);
            Serenity.EditorUtils.setReadOnly(this.form.PrimaryKey, isExpression);
            Serenity.EditorUtils.setReadOnly(this.form.IsNotNull, isExpression);
            Serenity.EditorUtils.setReadOnly(this.form.SqlDefault, isExpression);

            var dt = this.form.DataType.value;
            Serenity.EditorUtils.setReadOnly(this.form.DataPrecision, isExpression || 
                (dt != "decimal" && dt != "numeric" && dt != "nvarchar" && dt != "varchar" && dt != "time" && dt != "varbinary"));
            Serenity.EditorUtils.setRequired(this.form.DataPrecision, !isExpression && 
                (dt == "decimal" || dt == "numeric" || dt == "nvarchar" || dt == "varchar" || dt == "varbinary"));
            Serenity.EditorUtils.setReadOnly(this.form.DataScale, isExpression || 
                (dt != "decimal" && dt != "numeric"));
            Serenity.EditorUtils.setRequired(this.form.DataScale, 
                !isExpression && (dt == "decimal" || dt == "numeric"));

            if (!Authorization.userDefinition.IsDevelopment) {
                this.applyChangesButton.hide();
                this.saveAndCloseButton.hide();
                this.deleteButton.hide();
                Serenity.EditorUtils.setReadonly(this.element.find(":input"), true);
            }
        }
    }
}
